import VueRouter, { RouteConfig } from 'vue-router';
import { withPrefix } from '.';

export default (router: VueRouter): RouteConfig[] => {
  return withPrefix('/resources', [
    {
      path: '',
      name: 'resources',
      component: () => import('@/views/resource/Resources.vue'),
      redirect: { name: 'bookshelf-list' },
      children: [
        {
          path: 'bookshelves',
          name: 'bookshelf-list',
          component: () => import('@/views/resource/BookshelfList.vue'),
        },
        {
          path: 'items',
          name: 'resource-item-list',
          component: () => import('@/views/resource/ResourceList.vue'),
        },
      ],
    },

    ...withPrefix('/bookshelves', [
      {
        path: '/create',
        name: 'bookshelf-create',
        component: () => import('@/views/resource/BookshelfCreate.vue'),
      },
      {
        path: '/:id(\\d+)?',
        name: 'bookshelf-edit',
        component: () => import('@/views/resource/BookshelfEdit.vue'),
      },
    ]),
  ]);
};
